import { render, staticRenderFns } from "./StudentCoursesWidget.vue?vue&type=template&id=75cebcd1&scoped=true"
import script from "./StudentCoursesWidget.vue?vue&type=script&lang=js"
export * from "./StudentCoursesWidget.vue?vue&type=script&lang=js"
import style0 from "./StudentCoursesWidget.vue?vue&type=style&index=0&id=75cebcd1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cebcd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75cebcd1')) {
      api.createRecord('75cebcd1', component.options)
    } else {
      api.reload('75cebcd1', component.options)
    }
    module.hot.accept("./StudentCoursesWidget.vue?vue&type=template&id=75cebcd1&scoped=true", function () {
      api.rerender('75cebcd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/StudentCoursesWidget.vue"
export default component.exports